// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"cc17f1cd","879":"112425cd"}[chunkId] + ".chunk.js";
};